import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { CheckDto } from "./check-dto";

export class VenueSurveyItem {
	pk: string; //:venueKey
	sk: string = uuidv4(); //survey_key
	name: string;
	surveyId: string;
	questions: SurveyQuestion[] = [];
	created: string;
	updated: string;
	viewed: number;
	answered: number;
	lastViewed: string;
	lastAnswered: string;
	default: boolean;
	active: boolean;
	headerMessage: string;
	surveyGiftCardValue: number;
	surveyGiftCardThankYouMessage: string;
	requestContactInformation: SurveyContactInformation;
	surveyUrl: string;
	responseEmailAddress: string[] = [];
	responseSmsNumber: string[] = [];

	public constructor(init?: Partial<VenueSurveyItem>) {
		Object.assign(this, init);

		this.questions = this.questions?.map((i) => new SurveyQuestion(i));
	}
}

export class SurveyQuestion {
	key: string = uuidv4();
	sortOrder: number;
	question: string;
	answer: SurveyAnswer;
	conditionalDisplay: SurveyConditionalDisplay;

	public constructor(init?: Partial<SurveyQuestion>) {
		Object.assign(this, init);
	}
}

export class SurveyAnswer {
	type: SurveyAnswerType;
	scale: SurveyAnswerScale = new SurveyAnswerScale();
	boolean: SurveyAnswerBoolean = new SurveyAnswerBoolean();
	choice: SurveyAnswerChoice = new SurveyAnswerChoice();
	value: any;

	public constructor(init?: Partial<SurveyAnswer>) {
		Object.assign(this, init);
	}
}

class SurveyAnswerScale {
	min: number;
	max: number;
	step: number;
}

class SurveyAnswerBoolean {
	true: string;
	false: string;
}

class SurveyAnswerChoice {
	multiple: boolean;
	choices: string[] = [];

	public constructor(init?: Partial<SurveyAnswerChoice>) {
		Object.assign(this, init);
	}
}

export enum SurveyAnswerType {
	TEXT = 1,
	TEXTAREA = 2,
	SCALE = 3,
	BOOLEAN = 4,
	CHOICE = 5,
}

class SurveyConditionalDisplay {
	requiredQuestionKey: string;
	requiredAnswerBoolean: boolean;
	requiredAnswerScaleMin: number;
	requiredAnswerScaleMax: number;
}

class SurveyContactInformation {
	firstName: SurveyContactRequirement;
	lastName: SurveyContactRequirement;
	email: SurveyContactRequirement;
	phone: SurveyContactRequirement;
}

class SurveyContactRequirement {
	requested: boolean;
	required: boolean;
}

export class SurveyResponse {
	pk: string;
	sk: string;
	venueKey: number;
	checkKey: string;
	seatKey: number;
	surveyKey: string;
	responseDate: string;
	contactInformation: SurveyResponseContactInformation = new SurveyResponseContactInformation();
	questions: SurveyQuestion[];
	created: string = moment().format();
	note: SurveyNote[] = [];

	check: CheckDto;
	survey: VenueSurveyItem;

	public constructor(init?: Partial<SurveyResponse>) {
		Object.assign(this, init);
	}
}

class SurveyResponseContactInformation {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
}

export class SurveyNote {
	key: string;
	user: string;
	userKey: string;
	created: string;
	note: string;
	public: boolean;

	public constructor(init?: Partial<SurveyNote>) {
		Object.assign(this, init);
	}
}
